import moment from 'moment';

export default {
    userExtraEditableFields() {
        return {
            first_name: 'Prénom',
            last_name: 'Nom',
            is_client: 'L\'utilisateur est un client',
            enable_inspection_request_mail: 'Nouvelles demandes d\'inspections',
            enable_inspection_request_summary_mail: 'Récapitualtif des demandes d\'inspection',
            enable_vehicle_list_mail: 'Liste des véhicules à inspecter',
        };
    },
    userExtraEditableFieldsOptions() {
        return {
            first_name: { type: 'string' },
            last_name: { type: 'string' },
            is_client: { type: 'boolean' },
            enable_inspection_request_mail: { type: 'boolean' },
            enable_inspection_request_summary_mail: { type: 'boolean' },
            enable_vehicle_list_mail: { type: 'boolean' },
        };
    },

    enableCreateUserByImportCsv() {
        return true;
    },

    usersCanViewTheirOwnGroups(/*state, getters*/) {
        return true;
    },

    displayAppSearchBar() {
        return false;
    },

    enablePermissionAdministration() {
        return false;
    },

    currentSearchTerm: (state) => {
        return state.searchTerm;
    },

    // autoConnectionToFirstEntity: () => {
    //     return true;
    // },

    enableLoginByEmail() {
        return true;
    },

    canEditUser() {
        return true;
    },

    displayChooseEntityFullOverlay() {
        return false;
    },

    displayLoadingFullOverlay(state, getters, rootState, rootGetters) {

        // return false;
        return !getters.modelsLoaded;
    },

    // thisPlatformName() {
    //     return 'Flottes BRIDGESTONE';
    // },

    loginImage: () => {
        return 'static/img/login-image.jpg';
    },

    logoFileTopHeader: () => {
        return 'static/img/logo_80x35.png';
    },

    logoFile: () => {
        return 'static/img/logo_file.png';
    },

    logoFileTopHeaderBackgroundColor: () => {
        return '#e6e6e6';
    },

    logoFileBackgroundColor: () => {
        return 'rgba(255, 255, 255, 0.3)';
    },

    backgroundFile2: () => {
        return 'static/img/background_file_2.jpg';
    },

    backgroundFile1: () => {
        return 'static/img/background_file_1.jpg';
    },

    dashboardName: () => {
        return 'Inspection Manager';
    },

    sidebarName() {
        return 'Inspection Manager';
    },

    getSimpleLayoutHeaderBackgroundImage: () => {
        // default image
        return 'static/img/background_file_2.jpg';
    },
    enableCreateUser() {
        return true;
    },
    enableGroupsAdministration() {
        return true;
    },
    enableGroupsSideBarMenu() {
        return true;
    },
    setGroupsSideBarMenuManually() {
        return false;
    },
    enableUsersAdministration() {
        return true;
    },
    enableUsersSideBarMenu() {
        return true;
    },
    setUsersSideBarMenuManually() {
        return false;
    },

    enableDownloadCsvGroups() {
        return false;
    },
    enableDownloadCsvUsers() {
        return false;
    },
    enableDeleteGroup() {
        return false;
    },

    defaultLanguage() {
        return 'fr';
    },

    shouldFetchModelAclRoles() {
        return false;
    },
    shouldFetchModelAclPermissions() {
        return false;
    },
    displayFleetsPage(state, getters) {
        if (getters.currentUser) {
            return getters.getUserGroups(getters.currentUser.uid).length > 1
                || getters.isBridgestoneUser;
        } else {
            return false;
        }
    },

    getUserGroups: (state, getters) => (userUid) => {
        if (getters.isBridgestoneUser === true) {
            return getters.groups;
        }
        return getters.groups.filter((group) => {
            return group.members_uid.includes(userUid);
        });
    },

    isBridgestoneUser(state, getters) {
        return getters.userIsAtLeastAdmin;
    },

    selectedGroup(state, getters) {
        return getters.groupsByUid(getters.getSelectedFleet);
    },
    selectedBase(state, getters) {
        return getters.basesByUid(getters.selectedGroup.base_uid);
    },

    colorsConfig: () => {
        let config = {
            good: { color: '#c3e7b1', threshold: 0 },
            // moderate: {color: '#ffffcc', threshold: 20},
            severe: { color: '#f6dfbc', threshold: 23 },
            extreme: { color: '#f9b9b9', threshold: 30 },
        };
        let previous = null;
        let keys = Object.keys(config).sort(
            (key1, key2) => {
                return config[key1].threshold - config[key2].threshold;
            }
        );
        for (let key of keys.reverse()) {
            if (previous === null) {
                config[key].max = 10000;
            }
            else {
                config[key].max = previous.threshold - 1;
            }
            previous = config[key];
        }
        return config;
    },

    colorsConfigStatuses: (state, getters) => {
        return Object.keys(getters.colorsConfig).sort(
            (key1, key2) => {
                return getters.colorsConfig[key1].threshold - getters.colorsConfig[key2].threshold;
            }
        );
    },

    colorsConfigLastStatus: (state, getters) => {
        return getters.colorsConfigStatuses[getters.colorsConfigStatuses.length - 1];
    },

    colorsConfigFirstStatus: (state, getters) => {
        return getters.colorsConfigStatuses[0];
    },

    getVehicleInspectionStatus: (state, getters) => (vehicle) => {
        let config = getters.selectedBase.display_config;
        if (config === undefined || Object.keys(config).length === 0) {
            config = {};
            for (let statusName of getters.colorsConfigStatuses.slice(1)) {
                config[statusName] = { 'min': getters.colorsConfig[statusName].threshold };
            }
        }
        let today = moment();
        let lastInspectionDate = moment(vehicle.last_inspection_date);

        for (let statusName of getters.colorsConfigStatuses.slice(1).reverse()) {
            let threshold = moment(today).subtract(config[statusName].min, 'days');
            if (lastInspectionDate < threshold) {
                return statusName.toUpperCase();
            }
        }
        return getters.colorsConfigStatuses[0].toUpperCase();
    },

    getSelectedFleet(state, getters) {
        if (getters.currentUser) {
            if (getters.getUserGroups(getters.currentUser.uid).length == 1) {
                // l'utilisateur n'appartient qu'à un groupe
                return getters.getUserGroups(getters.currentUser.uid)[0].uid;
            } else {
                return state.selectedFleet;
            }
        } else {
            return '';
        }
    },

    isAFleetSelected(state, getters) {
        return getters.getSelectedFleet !== '';
    },

    getNumberVehiclesToInspect(state) {
        return state.numberVehiclesToInspect;
    },

    getNumberRequests(state) {
        return state.numberRequests;
    },
    getExtremeVehiculesInspectionCount(state) {
        return state.extremeVehiculesInspectionCount;
    },
    simpleLayoutIndicators(state, getters) {
        if (!getters.currentUser) {
            return [];
        } else if (!getters.currentUser.is_client) {
            return [
                {
                    title: getters.getNumberVehiclesToInspect,
                    subtitle: 'véhicules sur base',
                },
                {
                    title: getters.getExtremeVehiculesInspectionCount,
                    subtitle: 'véhicules à inspecter',
                },
                {
                    title: getters.getNumberRequests,
                    subtitle: 'requêtes en attente d\'une réponse',
                },
                // {
                //     title: '',
                //     subtitle: 'GMT/UTC + 1',
                // },
            ];
        } else {
            return [
                {
                    title: getters.getNumberRequests,
                    subtitle: 'requêtes en attente d\'une réponse',
                },
                // {
                //     title: '',
                //     subtitle: 'GMT/UTC + 1',
                // },
            ];
        }
    },

    displaySelectGroup(state, getters) {
        return getters.isAFleetSelected
            && (getters.getUserGroups(getters.currentUser.uid).length > 1
                || getters.isBridgestoneUser);
    },
};



// WEBPACK FOOTER //
// ./src/store/getters.js